"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";
import { usePdfDocumentStore } from "./pdfDocumentStore";
import { PdfThumbnailBar } from "./PdfThumbnailBar";
import { PdfOutlineTree } from "./PdfOutlineTree";
import { ThreadDocumentsPanel } from "@/components/document/ThreadDocumentsPanel";

/**
 * Expandable content panel for thumbnails / outline / generated documents list.
 * The icon strip that previously lived here has been relocated to the panel header.
 *
 * "documents" is wider than the thumbnail/outline lists because it shows multi-line
 * cards (title + version count); the other modes keep the slimmer 120px column.
 */
export const PdfSidebarViews = memo(function PdfSidebarViews() {
  const sidebarView = usePdfDocumentStore((s) => s.sidebarView);
  const expanded = sidebarView !== "none";
  const wide = sidebarView === "documents";

  return (
    <div
      className={cn(
        "h-full overflow-hidden border-r border-border/30 transition-[width] duration-200 ease-linear shrink-0 bg-muted/10",
        !expanded && "w-0 border-r-0",
        expanded && (wide ? "w-[200px]" : "w-[120px]"),
      )}
    >
      {sidebarView === "thumbnails" && <PdfThumbnailBar />}
      {sidebarView === "outline" && <PdfOutlineTree />}
      {sidebarView === "documents" && <ThreadDocumentsPanel />}
    </div>
  );
});
